import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLayoutCheckout, LazyLayoutDefault, LazyPromotionsAmersfoort, LazyPromotionsBase, LazyPromotionsBigParty, LazyPromotionsDefault, LazyPromotionsEasterStack, LazyPromotionsExtra20Off, LazyPromotionsFreeGift, LazyPromotionsFreeshipping, LazyPromotionsGutsJeansV2, LazyPromotionsImageTemplate, LazyPromotions, LazyPromotionsParty, LazyPromotionsPregnantFaves, LazyPromotionsSharedScript, LazyPromotionsTravel, LazyPromotionsWarsocks, LazyPromotionsWeddingGuests, LazyPromotionsWomensDay, LazyPromotionsXmasStack, LazySbBox, LazySbButton, LazySbCheckbox, LazySbCollapse, LazySbContainer, LazySbForm, LazySbFormDate, LazySbFormInput, LazySbGenericPage, LazySbHeading, LazySbHero, LazySbHomePage, LazySbLandingPage, LazySbMultipleChoice, LazySbSpacer, LazySbTable, LazySbText, LazySbTile } from '#components'
const lazyGlobalComponents = [
  ["LayoutCheckout", LazyLayoutCheckout],
["LayoutDefault", LazyLayoutDefault],
["PromotionsAmersfoort", LazyPromotionsAmersfoort],
["PromotionsBase", LazyPromotionsBase],
["PromotionsBigParty", LazyPromotionsBigParty],
["PromotionsDefault", LazyPromotionsDefault],
["PromotionsEasterStack", LazyPromotionsEasterStack],
["PromotionsExtra20Off", LazyPromotionsExtra20Off],
["PromotionsFreeGift", LazyPromotionsFreeGift],
["PromotionsFreeshipping", LazyPromotionsFreeshipping],
["PromotionsGutsJeansV2", LazyPromotionsGutsJeansV2],
["PromotionsImageTemplate", LazyPromotionsImageTemplate],
["Promotions", LazyPromotions],
["PromotionsParty", LazyPromotionsParty],
["PromotionsPregnantFaves", LazyPromotionsPregnantFaves],
["PromotionsSharedScript", LazyPromotionsSharedScript],
["PromotionsTravel", LazyPromotionsTravel],
["PromotionsWarsocks", LazyPromotionsWarsocks],
["PromotionsWeddingGuests", LazyPromotionsWeddingGuests],
["PromotionsWomensDay", LazyPromotionsWomensDay],
["PromotionsXmasStack", LazyPromotionsXmasStack],
["SbBox", LazySbBox],
["SbButton", LazySbButton],
["SbCheckbox", LazySbCheckbox],
["SbCollapse", LazySbCollapse],
["SbContainer", LazySbContainer],
["SbForm", LazySbForm],
["SbFormDate", LazySbFormDate],
["SbFormInput", LazySbFormInput],
["SbGenericPage", LazySbGenericPage],
["SbHeading", LazySbHeading],
["SbHero", LazySbHero],
["SbHomePage", LazySbHomePage],
["SbLandingPage", LazySbLandingPage],
["SbMultipleChoice", LazySbMultipleChoice],
["SbSpacer", LazySbSpacer],
["SbTable", LazySbTable],
["SbText", LazySbText],
["SbTile", LazySbTile],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
